import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { getPodcastCategoryWise } from "../../../redux/action/dashboard/dashboardAction";

const BarChart = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPodcastCategoryWise());
  }, [dispatch]);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const truncateLength = screenWidth < 600 ? 10 :  (screenWidth < 900 ? 13 : screenWidth < 1200  ? 22 : screenWidth < 1480  ? 10 : screenWidth < 2000  ?  28 : 22);


  const podcastCategoryWise = useSelector(
    (state) => state.dashboardData?.podcastCategoryWise?.data
  );

  const chartOptions = {
    chart: {
      id: "bar-chart",
      toolbar: { show: false },
    },
    grid: {
      padding: {
        left: 30,
      },
    },
    xaxis: {
      categories: podcastCategoryWise?.map((item) =>
        item?.category_name_en?.length > truncateLength
          ? item?.category_name_en.slice(0, truncateLength) + "..."
          : item?.category_name_en
      ),
    },
    title: {
      text: "Category-wise Comparison",
      align: "left",
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: false,
        columnWidth: "50%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 1750,
        options: {
          xaxis: {
            labels: {
              rotate: -30,
            },
          },
        },
      },
      {
        breakpoint: 1450,
        options: {
          xaxis: {
            labels: {
              rotate: -45,
            },
          },
        },
      },
    ],
  };

  const chartSeries = [
    {
      name: "Listeners",
      data: podcastCategoryWise?.map((item) => item?.listener_count),
    },
    {
      name: "Completed",
      data: podcastCategoryWise?.map((item) => item?.complete_count),
    },
  ];

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default BarChart;
